export const APP_NAME = "XBRLab";
export const TOKEN_NAME = "XBR";

export const TOKEN_MIN_AMOUNT = 20;
export const TOKEN_MAX_AMOUNT = 50000;
